import PropTypes from 'prop-types';

const Message = ({
	found,
	term,
}) => (
	<>
		Found
		{' '}
		<strong>{found}</strong>
		{' '}
		{found === 1 ? 'result' : 'results'}
		{' '}
		for
		{' '}
		<strong>
			&quot;
			{term}
			&quot;
		</strong>
	</>
);

Message.propTypes = {
	found: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	term: PropTypes.string.isRequired,
};

const SearchTitle = ({
	found,
	term,
}) => (
	<>
		<h3 className="search-title">
			<Message found={found} term={term} />
		</h3>
		<span className="visually-hidden" role="status">
			{typeof found === 'number' && (
				<Message found={found} term={term} />
			)}
		</span>
	</>
);

SearchTitle.propTypes = {
	found: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	term: PropTypes.string.isRequired,
};

export default SearchTitle;
